
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import {
  useGetOutletQuery,
  useGetTaxSchemeListingQuery,
  usePaymentCodeInsertMutation,
  usePaymentCodeListingQuery,
  usePaymentCodeUpdateMutation,
} from 'generated/graphql';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import React, { Reducer, useCallback, useEffect, useReducer} from 'react';
import { useHistory, useLocation} from 'react-router-dom';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import { IAction } from 'helpers/model';


type valueFields = {
  value?: any
  error?: boolean
  errorMessage?: string
}

interface FormProps {
  paymentMode?: valueFields
  name?: valueFields
  code?: valueFields
  taxScheme?: valueFields
  Dialog: boolean
  DialogMode?: string
}

export const PaymentCodeForm = ({ FormMode, mode }: { FormMode: string; mode: string }) => {
  useEffect(() => {
    console.log('BankTTForm');
  }, []);
  const {
    anchorEl,
    handleClose,
  } = useMenuOption();
  const location = useLocation();
  const localState = location.state as any;
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const { snackFunc, close, snackBarMessage, openSnackBar } = useSnackBar()
  const outletID = localStorage.getItem('latestOutlet');
  const reducer: Reducer<FormProps, IAction> = (state, action) => {
      switch (action.type) {
        case 'reset':
          return initialState;
        default:
          return { ...state, [action.type]: action.payload };
      }
    };
    const initialState: FormProps = {
    paymentMode: {
      value: FormMode === 'Add' ? '' : localState?.paymentMode,
      error: false,
    },
    name: {
      value: FormMode === 'Add' ? '' : localState?.name,
      error: false,
    },
    code: {
      value: FormMode === 'Add' ? '' : localState?.code,
      error: false,
    },
    taxScheme: {
      value: FormMode === 'Add' ? null : localState?.TaxScheme,
      error: false,
    },
    Dialog: false,
    DialogMode: '',
  }
  const [state, dispatch] = useReducer(reducer, initialState);

  const {
      data: { getTaxSchemeListing } = { getTaxSchemeListing: [] },
      loading: taxSchemeListingLoading,
      refetch,
    } = useGetTaxSchemeListingQuery({
      fetchPolicy: 'network-only',
      variables: {
        accountID: user?.accountID,
      },
    });

    console.log(getTaxSchemeListing, 'getTaxSchemeListing');
    console.log(localState,state, 'localState');
    const [
    PaymentCodeInsert,
    { loading: insertLoading, error: insertError },
  ] = usePaymentCodeInsertMutation({})
  const [
    PaymentCodeUpdate,
    { loading: updateLoading, error: updateError },
  ] = usePaymentCodeUpdateMutation({})

  const {
    data,
    loading: paymentCodeListingLoading,
  } = usePaymentCodeListingQuery({
    variables: {
      OutletID: outletID,
      PaymentMode: mode,
    },
    fetchPolicy: 'no-cache',
  });
  const PaymentCodeListing = data?.PaymentCodeListing;

  const isDuplicateCode = useCallback(
    (code: string) => {
      const normalizedCode = code?.trim()?.toLowerCase();
      if (!normalizedCode || !PaymentCodeListing?.length) return false;

      return PaymentCodeListing.some(
        item =>
          item?.code?.trim()?.toLowerCase() === normalizedCode &&
          (FormMode.toLowerCase() !== 'edit' || item?.ID !== localState?.ID),
      );
    },
    [PaymentCodeListing, FormMode, localState?.ID],
  );

  const handleCodeChange = useCallback(
    (value: string) => {
      const duplicate = isDuplicateCode(value);

      dispatch({
        type: 'code',
        payload: {
          value,
          error: duplicate,
          errorMessage: duplicate ? `${mode} code already exists` : undefined,
        },
      });
    },
    [isDuplicateCode, mode],
  );

const onSubmit = () => {
  const code = state.code?.value?.trim();
  const name = state.name?.value?.trim();

  if (!code) {
    dispatch({
      type: 'code',
      payload: {
        value: state.code?.value,
        error: true,
        errorMessage: `${mode} code is required`,
      },
    });
    return;
  }

  if (!name) {
    dispatch({
      type: 'name',
      payload: {
        value: state.name?.value,
        error: true,
        errorMessage: `${mode} name is required`,
      },
    });
    return;
  }

  if (isDuplicateCode(code)) {
    dispatch({
      type: 'code',
      payload: {
        value: state.code?.value,
        error: true,
        errorMessage: `${mode} code already exists`,
      },
    });
    return;
  }

  const data = {
    name,
    code,
    // taxSchemeID: state.taxScheme?.value?.id,
    paymentMode: mode,
  };

  if (FormMode.toLowerCase() === 'add') {
    PaymentCodeInsert({
      variables: {
        PaymentCodeInput: {
          outletID,
          accountID: user?.accountID,
          ...data,
        },
      },
    }).then(res => {
      if (res?.data?.PaymentCodeInsert?.ID) {
        snackFunc('Insert Successfully', true);
      } else {
        snackFunc('Insert Fail!', false);
      }
    }).catch(err => {
      snackFunc(err?.message?.replace('GraphQL error: ', '') || 'Insert Fail!', false);
    });
  }
   else if (FormMode.toLowerCase() === 'edit') {
    PaymentCodeUpdate({
      variables: {
        PaymentCodeInput: {
          ID: localState?.ID,
          outletID,
          accountID: user?.accountID,
          name,
          code,
          // taxSchemeID: state.taxScheme?.value?.id,
        },
      },
    }).then(res => {
      if (res?.data?.PaymentCodeUpdate) {
        snackFunc('Update Successfully', true);
      } else {
        snackFunc('Update Fail!', false);
      }
    }).catch(err => {
      snackFunc(err?.message?.replace('GraphQL error: ', '') || 'Update Fail!', false);
    });
  }
};

  const {
    called: outletCalled,
    loading: outletLoading,
    error: outletError,
    data: { getOutlet } = { getOutlet: [] },
  } = useGetOutletQuery({
    fetchPolicy: 'network-only',
    variables: { ID: outletID },
  });

  const history = useHistory();

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: any) => option.name,
  });


  return (
    <>
      {insertLoading && <Loading />}
      {updateLoading && <Loading />}
      {paymentCodeListingLoading && <Loading />}
      <MainHeader
       onClick={() =>
            mode === 'Bank TT' ? history.push('/menu/outlet-app/account-journals/account-mapping/bank-tt')
          : history.push('/menu/outlet-app/account-journals/account-mapping/voucher')
          }
        mainBtn="close"
        smTitle={`Outlet App`}
        title={getOutlet[0]?.name}
        routeSegments={[
          { name: 'Account Journals' },
          { name: mode === 'Bank TT' ? 'Bank TT' : 'Voucher', current: true },
        ]}
        rightRouteSegments={[{ name: mode === 'edit' ? 'Edit' : 'Add' }]}
      />
       <ContentWrapper footer>
        <CardContents>
          <TextField
            label={`${mode} Code`}
            margin="normal"
            fullWidth
            required
            value={state.code?.value}
            error={state.code?.error}
            helperText={state.code?.error ? state.code?.errorMessage : undefined}
            onChange={(e) => handleCodeChange(e.target.value)}
          />
          <TextField
            label={`${mode} Name`}
            margin="normal"
            fullWidth
            required
            value={state.name?.value}
            error={state.name?.error}
            helperText={
              state.name?.error ? state.name?.errorMessage : undefined
            }
            onChange={e =>
              dispatch({
                type: 'name',
                payload: { value: e.target.value, error: false, errorMessage: undefined },
              })
            }
          />
          {/* <Autocomplete
          options={getTaxSchemeListing}
          getOptionLabel={(option) => option?.name}
          value={state?.taxScheme?.value}
          fullWidth
          onChange={(e, value) => 
            // console.log(e, value?.id, 'northlion')
            dispatch({
            type: 'taxScheme',
            payload: { ...state.taxScheme, value},
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              className="left"
              style={{ width: '100%' }}
              label="Tax Scheme"
              variant="standard"
              required
            />
          )}
          renderOption={(option) => (
            <div>
              <div 	className="fw-normal" style={{fontSize: '13px'}}>
                <b>{option.name}</b>
              </div>
              <div 	className="fw-normal" style={{fontSize: '13px'}}>
                {option.description ? option.description : '-'} 
                {option?.isExclusive === true ? '(E)' : '(I)'}
              </div>
            </div>
          )}
          /> */}
        </CardContents>
      </ContentWrapper>
      <Menu
        className="menu-list"
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem onClick={() => dispatch({ type: 'EditDialog', payload: {} })}>
          Edit
        </MenuItem>

        <MenuItem>
          Delete
        </MenuItem>
      </Menu>
      <SnackBarMsg open={openSnackBar} message={snackBarMessage} />
      


      <Footer
        options={[
          {
            name: `Save`,
            onClick: () => onSubmit(),
            color: state.code?.error ? 'inherit' : 'primary',
            props: {
              type: 'submit',
              disabled: state.code?.error,
            },
          },
        ]}
      />
    </>
  );
};
